interface CustomButtonProps {
  buttonText?: string;
  disabled?: boolean;
  onClick?: () => void;
}

const CustomButton = ({ buttonText, disabled, onClick }: CustomButtonProps) => {
  return (
    <button
      onClick={onClick}
      className={`btn fg-btn fg-btn-filled-darkblue ${
        disabled ? "inactive" : ""
      } w-100`}
      disabled={disabled}
      data-testid="customButton"
    >
      {buttonText}
    </button>
  );
};

export default CustomButton;
